import React, { memo } from 'react';

import { EListingSource } from '@/services/analytics/listings/types';
import { IRentalTile } from '@/utility/mapSearchResultToTile';

import { EBundledListingsTileOrientation } from './BookAnRVSuite';
import { BundledListingsPlaceholderTile } from './BundledListingsPlaceholderTiles';
import { BundledListingsTile } from './BundledListingsTile';

interface IBundledListingsProps {
  listingsData: IRentalTile[];
  scrollToSearchFilter?: () => void;
  orientation: EBundledListingsTileOrientation;
  isLoadingData: boolean;
}

export const BundledListings = memo(
  ({
    listingsData,
    scrollToSearchFilter,
    orientation = EBundledListingsTileOrientation.Vertical,
    isLoadingData,
  }: IBundledListingsProps) => {
    if (isLoadingData) {
      // return placeholder tile while the new data is being loaded
      return <BundledListingsPlaceholderTile orientation={orientation} />;
    }

    return (
      <ul
        className={`grid gap-6 md:gap-8 grid-cols-1 md:grid-cols-2 ${
          orientation === EBundledListingsTileOrientation.Vertical ? 'lg:grid-cols-3' : ''
        }`}>
        {listingsData.map((listing, index) => {
          return (
            <li key={listing.id || index}>
              <BundledListingsTile
                rv={listing}
                wishlistingEventData={{
                  index,
                  eventSource: EListingSource.VACATION_PACKAGES,
                }}
                scrollToSearchFilter={scrollToSearchFilter}
              />
            </li>
          );
        })}
      </ul>
    );
  },
);

BundledListings.displayName = 'BundledListings';
